export const renderInputNativeInputChild = (hostEl: HTMLElement, props: { type: string; [key: string]: any }): void => {
  let inputEl = hostEl.querySelector<HTMLInputElement>('input');

  if (!inputEl) {
    inputEl = hostEl.ownerDocument.createElement('input');
    inputEl.style.display = 'none';
    inputEl.setAttribute('aria-hidden', 'true');
    inputEl.type = props.type;
    hostEl.appendChild(inputEl);
  }

  Object.keys(props).forEach((key) => (inputEl[key] = props[key]));
};
